import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategoriesSection() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10 md:mb-14">
          <p className="text-xs md:text-sm text-foreground-500 font-medium tracking-widest uppercase mb-2">
            {t("categories.subtitle")}
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-3">
            {t("categories.title")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl">
            {t("categories.description")}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-2xl overflow-hidden aspect-[3/4] cursor-pointer"
            >
              <img
                src={cat.imageUrl}
                alt={`${cat.name} in OOPBuy spreadsheet`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                <span className="inline-block px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs md:text-sm font-medium text-foreground-900 whitespace-nowrap">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}